package com.narbase.letsgo.web.views.support

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.web.dto.support.SupportIssueDto
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.support.GetSupportIssuesByCategoryEndpoint
import com.narbase.letsgo.web.routing.domain.admin.support.UpsertSupportIssueEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class SupportIssuesManagementViewModel(
    val categoryId: KmmLong
) {

    val uiState = Observable<BasicUiState>()
    val getUiState = Observable<BasicUiState>()
    val upsertUiState = Observable<BasicUiState>()
    var supportIssuesList : List<SupportIssueDto> = listOf()

    var pageNo = 0
    var pageSize = 20
    var total = 0
    fun getSupportIssues(){
        basicNetworkCall(getUiState) {
            val dto = GetSupportIssuesByCategoryEndpoint.Request(categoryId, null,pageNo, pageSize, null )
            val response = GetSupportIssuesByCategoryEndpoint.remoteProcess(dto).data
            supportIssuesList = response.list.toList()
            total = response.total
        }
    }

    fun upsertSupportIssue(supportIssue: SupportIssueDto){
        basicNetworkCall(upsertUiState) {
            val dto = UpsertSupportIssueEndpoint.Request(supportIssue)
            UpsertSupportIssueEndpoint.remoteProcess(dto).data
        }

    }

    fun searchFor(term: String) {
        pageNo = 0
        uiState.value = BasicUiState.Loaded
        getSupportIssues()
    }

    fun getNextPage() {
        pageNo++
        getSupportIssues()
    }

    fun getPreviousPage() {
        pageNo--
        getSupportIssues()
    }
}